import { SectionOfContent } from '@contentful-components/section-of-content'
import type { SectionFragment } from '@graphql/fragments/SectionFragment.graphql'
import type { FunctionComponent } from 'react'

/**
 * Renders a section, styled for articles.
 */
export const ArticleSection: FunctionComponent<SectionFragment> = (props) => (
    <SectionOfContent padHorizontal={false} {...props} />
)
